import { Component, OnInit, Input, inject } from '@angular/core';
import { GlobalEnumerationsAceInformationsquelle } from '@/api/models/ace/xFound/Portal/Core/Entities/global-enumerations-ace-informationsquelle';
import { EnumValue } from '@/core/models/enumvalue.model';
import { I18nService } from '@/core/services/i18nService';
import { StateService } from '@/core/services/state.service';
import { SectionService } from '@/core/services/section.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { InstitutionDisplayModelFormGroup} from '@/api/model-index';

@Component({
    selector: 'institution-form',
    templateUrl: './institution-form.component.html',
    styleUrls: ['./institution-form.component.scss'],
    standalone: false
})
export class InstitutionFormComponent implements OnInit {
  @Input('form') institutionDataForm: InstitutionDisplayModelFormGroup;

  public get informationsquelleList(): EnumValue[] {
    return this.translateservice.getEnumValues(GlobalEnumerationsAceInformationsquelle);
  }

  constructor(protected translateservice: I18nService, protected stateService: StateService, protected sectionService: SectionService, protected portalContextService: PortalContextService) {
  }

  ngOnInit(): void {
    /*if (this.stateService.IsEndvalidationEnabled) {
      this.institutionDataForm.Informationsquelle.addValidators(Validators.required);
      this.institutionDataForm.markAllAsTouched();
    }*/
  }
}
